module.exports = __webpack_public_path__ + "static/Hero-93a2fbbc3add6dd943309ed6fc3f930c.jpg";